import { combineReducers } from 'redux';
import { sessionReducer } from 'redux-react-session';

import { appReducer } from './app';
import { efectoreslistsReducer } from './efector-lists';
import { efectoresReducer } from './efectores';
import { efectoresImportLogReducer } from './efectores-import-log';
import { orderListsReducer } from './orders-lists';
import { ordersReducer } from './orders';
import { locationsReducer } from './locations';
import { locationsListsReducer } from './locations-lists';
import { provincesListReducer } from './provinces-lists';
import { specialtiesListReducer } from './specialties-lists';
import { providerReducer } from './providers';
import { practiceListsReducer } from './practice-lists';
import { practicesReducer } from './practices';
import { practicesEfectoresReducer } from './practice-efectores';
import { practicesEfectoresVisitsReducer } from './practice-efector-visits';
import { addressReducer } from './address';
import { notificationsReducer } from './notifications';
import { notificationListsReducer } from './notifications-lists';


export default combineReducers({
	app: appReducer,
	efectorlists: efectoreslistsReducer,
	efectores: efectoresReducer,
    efectoresImportLog: efectoresImportLogReducer,
	orderlists: orderListsReducer,
	orders: ordersReducer,
	locationslist: locationsListsReducer,
	specialties: specialtiesListReducer,
	provider: providerReducer,
	session: sessionReducer,
	practicelists: practiceListsReducer,
	practices: practicesReducer,
	practicesefectores: practicesEfectoresReducer,
	provinces: provincesListReducer,
	locations: locationsReducer,
	practicesefectoresvisits: practicesEfectoresVisitsReducer,
	address:	addressReducer,
	notifications: notificationsReducer,
	notificationlists: notificationListsReducer
});
